import React, { useEffect } from "react";
import MiniDrawer from "../../Component/newNavBar/newNavBar";

import TextEditor from "../../Component/Editor/Editor";
import Styles from "./NewEditorPageStyles.module.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { anotherExpertAnsweredQuestion, declinedAnswers } from "../../API/api";
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import NewEditorText from "../../NewComponent/NewEditor/NewEditorText";
import { Height } from "@mui/icons-material";
import Layout from "../../NewComponent/LayoutExpert/Layout";
const containerStyles = {
  width: "80%",
  margin: "auto",
  // marginTop:"1%",
  // marginTop: "6%",
  marginBottom: "7%",
  border: '1px solid #EAECF0',
  boxShadow: '0px 4px 16px 0px #1018280F',
  borderRadius: '12px',
  // minHeight:'450px',
  padding: '0px 24px 24px 24px',
  // Height:"100%"




};
const containerStyles1 = {
  width: "80%",
  margin: "auto",
  // marginTop:"1%",
  // marginTop: "6%",
  // marginBottom: "7%",
  // border: '1px solid #EAECF0',
  // boxShadow: '0px 4px 16px 0px #1018280F',
  // borderRadius: '12px',
  // minHeight:'450px',
  padding: '0px 24px 0px 0px',
  // paddingBottom:'0px'
  // Height:"100%"




};
const NewEditorPage = () => {
  const name = "answeredQuestions";
  let pageState = useSelector((state) => state[name]);
  const editorState = useSelector((state) => state.editor);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const expertState = useSelector((state) => state.expertOpenData);
  // expertState.getScrollPosition;
  const {updatePageNoAnswered, updateAnotherExpertAnsweredForEditor,updateNewDeclinedLoader,updateRatingBoolean,AnsweredPageBool,CheckEditAnswerBrief, updateDeclinedAnsweredForEditor, getSeekerAttachment, updatePageNumberExpertOpenTab, ChangePublishButton,isBackClickedOnRecommend,getScrollPositionInExpertOpen } = bindActionCreators(Actions, dispatch)
  const getOtherExpertAnswers = () => {
    anotherExpertAnsweredQuestion(editorState.data.questionUuid).then(res => {
      if (res === undefined) {
        updateRatingBoolean(false)
        return;
      }
      res.data.data.answersList = res.data.data.answers;
      updateAnotherExpertAnsweredForEditor(res.data.data);
    })
  }
  const getDeclinedAnswers = () => {
    updateNewDeclinedLoader(true)
    declinedAnswers(editorState?.data?.questionUuid).then(res => {
      // console.log("response",res.data.data[0].searchData)
      if(res?.data?.success){
        updateRatingBoolean(false)
      }
      if (res === undefined) {
        updateRatingBoolean(false)
        return;
      }
    
            
      updateDeclinedAnsweredForEditor(res?.data?.data[0]?.searchData);
    })
  }

  // const sendToOpenTab = () => {
  //   navigate(-1);
  //   isBackClickedOnRecommend(true);
  //   resetStateForEditor()
  
  //   setTimeout(() => {
  //     isBackClickedOnRecommend(false);
  //     console.log("here change")
    
  //     //
  //   }, 1000);
  //   // navigate(-1)
    
    
  // };
  const sendToOpenTab = () => {
    updatePageNumberExpertOpenTab(0)
    navigate(-1);
    // console.log("click",expertState.getScrollPosition)
    getScrollPositionInExpertOpen(expertState.getScrollPosition)
    if(editorState.pageNumber!==0){
      updatePageNoAnswered(editorState.pageNumber)
      updateRatingBoolean(true)
      }
      else {
      updateRatingBoolean(true)
      AnsweredPageBool(!editorState.answeredBoolean);
      }

    isBackClickedOnRecommend(true);
    setTimeout(() => {
      isBackClickedOnRecommend(false);
    }, 1000);
  };

  const redirectToHome = () => {
    navigate("/expertHome/open");
    return <p></p>;
  };
  useEffect(() => {
    ChangePublishButton(false)
    if (editorState.data !== null) {
      updateRatingBoolean(true)
      getOtherExpertAnswers();
      getDeclinedAnswers();
    }
    return () => {
      CheckEditAnswerBrief(false)
      if (editorState.seekerAttachments !== undefined && (editorState.seekerAttachments !== null || editorState.seekerAttachments.length !== 0)) {
        getSeekerAttachment([])
      }
    }
  }, [])
  return <>
    <div>


      <Layout>
        {editorState.data !== null ? (
          <>
          
        
          <div style={containerStyles1}>
          <span
            className={Styles.backButtonNew}
            style={{ cursor: "pointer" }}
            onClick={() => sendToOpenTab()}
          >
            <i className="fa fa-arrow-left"></i>&nbsp;Back
          </span>
        </div>

          <div style={containerStyles}>
          <NewEditorText />
     
          </div>
          </>
        ) : (
          redirectToHome()
        )}
      </Layout>
    </div>

  </>
}


export default NewEditorPage